import React from 'react';
import PropTypes from 'prop-types';
import {
  WrapperRadio,
  StyledLabel,
  StyledRadio,
  StyledCheckable
} from './style';

const RadioButtonSmall = ({
  className,
  ellipse,
  label,
  required,
  name,
  value,
  onChange,
  checked,
  disabled
}) => {
  const id = Date.now() * Math.floor(Math.random() * 1000);
  return (
    <WrapperRadio className={className}>
      <StyledCheckable
        ellipse={ellipse}
        checked={checked}
        disabled={disabled}
      />
      <StyledRadio
        required={required}
        disabled={disabled}
        id={id}
        name={name}
        value={value}
        onChange={event =>
          !disabled ? onChange(event.currentTarget.value, event) : () => {}
        }
        checked={checked}
      />
      <StyledLabel htmlFor={id} checked={checked} disabled={disabled}>
        {label}
      </StyledLabel>
    </WrapperRadio>
  );
};

RadioButtonSmall.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // Le pasamos PropTypes.node para que pueda recibir HTML el Label
  required: PropTypes.bool,
  ellipse: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};

RadioButtonSmall.defaultProps = {
  required: false,
  ellipse: false
};

export default RadioButtonSmall;
